let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gumMy")).then(() => parcelRequire('4j6Gh'));